// export const hasConsent = () => {
//   try {
//     const consent = localStorage.getItem("cardsfolioConsent");
//     return consent === "true";
//   } catch (err) {
//     console.warn("Unable to check cookie consent:", err);
//     return false;
//   }
// };

export const hasConsent = () => {
  try {
    return document.cookie.split(';').some(cookie => 
      cookie.trim().startsWith('cardsfolioConsent=true')
    );
  } catch (err) {
    console.warn("Unable to check cookie consent:", err);
    return false;
  }
};
